var _path, _g, _path2, _g2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncClouds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 68,
    viewBox: "0 0 128 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_109_54559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0410156 0.653076H127.166V67.9596H0.0410156V0.653076Z",
    fill: "#1CCFCA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_109_54559)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.91 68.0001H69.3204C69.3049 68.0001 69.29 67.9994 69.2745 67.9994C62.4255 67.9745 56.4721 63.2125 54.7343 56.4017C54.5505 55.6806 54.9878 54.9481 55.7117 54.765C56.4376 54.5825 57.171 55.0175 57.3548 55.7379C58.7918 61.3724 63.6962 65.307 69.2812 65.307H110.473C110.572 65.2733 110.676 65.2504 110.785 65.2403C118.582 64.5119 124.462 57.7893 124.462 49.603C124.462 41.4531 118.374 34.5777 110.601 33.9509C110.101 33.9105 109.664 33.5975 109.467 33.1383C106.406 26.0037 99.591 21.3945 92.1053 21.3945C87.8694 21.3945 83.8612 22.8164 80.5148 25.5075C79.9329 25.9754 79.0819 25.8838 78.6135 25.3062C78.1444 24.7272 78.2357 23.8795 78.8163 23.4123C82.6493 20.33 87.2448 18.7014 92.1053 18.7014C100.416 18.7014 107.995 23.6405 111.625 31.3508C120.403 32.4825 127.166 40.3422 127.166 49.603C127.166 59.0322 120.454 66.8077 111.481 67.8748C111.308 67.955 111.115 68.0001 110.91 68.0001Z",
    fill: "#DCF34B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_109_54559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0410156 0.653076H127.166V67.9596H0.0410156V0.653076Z",
    fill: "#1CCFCA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_109_54559)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7709 15.3249C62.5796 6.38527 53.7603 0.653076 44.0861 0.653076C31.9589 0.653076 21.5486 9.6486 19.3357 21.795C18.6841 21.7189 18.0285 21.6799 17.3769 21.6799C7.79524 21.6799 0 29.7073 0 39.5747C0 49.4205 7.76077 57.4351 17.3701 57.4681C17.3877 57.4688 17.4053 57.4694 17.4229 57.4694H66.0916C66.3079 57.4694 66.5113 57.4189 66.6925 57.3294C77.0967 56.1216 84.8839 47.1752 84.8839 36.3214C84.8839 25.6306 76.9913 16.5657 66.7709 15.3249Z",
    fill: "#DCF34B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5184 43.4317C37.7168 43.4317 32.1831 37.9197 32.1831 31.1446C32.1831 27.5648 33.7323 24.2221 36.3927 21.904L35.9959 23.8814C35.8492 24.6105 36.3244 25.3202 37.0564 25.4656C37.1456 25.4838 37.2349 25.4925 37.3227 25.4925C37.954 25.4925 38.5184 25.0495 38.6468 24.4099L39.6228 19.5482C39.7688 18.8191 39.2943 18.1095 38.5623 17.964L33.6816 16.9918C32.9503 16.843 32.2372 17.319 32.0912 18.0475C31.9445 18.7767 32.419 19.4863 33.1517 19.6324L34.5711 19.9152C31.3531 22.7388 29.4795 26.7987 29.4795 31.1446C29.4795 39.4042 36.2264 46.1248 44.5184 46.1248C45.2653 46.1248 45.8703 45.5215 45.8703 44.7783C45.8703 44.0343 45.2653 43.4317 44.5184 43.4317Z",
    fill: "#01313D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8862 42.6563L54.4668 42.3735C57.6841 39.5491 59.5578 35.49 59.5578 31.1447C59.5578 22.8844 52.8115 16.1646 44.5188 16.1646C43.7726 16.1646 43.167 16.7671 43.167 17.5111C43.167 18.2544 43.7726 18.8576 44.5188 18.8576C51.3205 18.8576 56.8541 24.3697 56.8541 31.1447C56.8541 34.7238 55.3049 38.0666 52.6446 40.3847L53.042 38.4066C53.188 37.6775 52.7135 36.9685 51.9815 36.8224C51.2488 36.6743 50.5371 37.1496 50.3911 37.8788L49.4151 42.7404C49.2684 43.4696 49.7429 44.1785 50.4756 44.3246L55.3556 45.2968C55.4455 45.315 55.5348 45.3238 55.6219 45.3238C56.2539 45.3238 56.8183 44.8807 56.9467 44.2405C57.0927 43.5113 56.6182 42.8017 55.8862 42.6563Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncClouds);
export default __webpack_public_path__ + "static/media/sync-clouds.453fa4634ee67a91f56b94406d8acd6f.svg";
export { ForwardRef as ReactComponent };